import type {
  ContentItemPlatform,
  ContentItemType,
} from '../generated/social-media/metapicSocialMediaAPIDocumentation.schemas'

import type { ListItems } from './common.types'

export const SUPPORTED_CONTENT_ITEM_PLATFORMS = ['instagram', 'snapchat', 'tiktok'] as const

export type SupportedContentItemPlatform = (typeof SUPPORTED_CONTENT_ITEM_PLATFORMS)[number]

// Compile-time guard: the UI subset must stay a subset of the generated platform union.
// If the OpenAPI drops one of these platforms, this assignment stops compiling.
const _platformSubsetGuard: readonly ContentItemPlatform[] = SUPPORTED_CONTENT_ITEM_PLATFORMS
void _platformSubsetGuard

// `satisfies`, not an annotation: an annotation collapses these tuples to ContentItemType[] and
// silently widens the per-platform constraint to "any content type, any platform".
//
// The order within each tuple is canonical: it drives the submenu, the selection the submenu emits and
// the `?source=` serialization alike. Reordering here reorders all three.
export const PLATFORM_CONTENT_TYPES = {
  instagram: ['instagram_story', 'instagram_post', 'instagram_reel'],
  snapchat: ['snapchat_story', 'snapchat_snap'],
  tiktok: ['tiktok_post'],
} as const satisfies Record<SupportedContentItemPlatform, readonly ContentItemType[]>

export const ALL_CONTENT_TYPES: readonly ContentItemType[] =
  SUPPORTED_CONTENT_ITEM_PLATFORMS.flatMap(
    (platform) => PLATFORM_CONTENT_TYPES[platform] as readonly ContentItemType[],
  )

export type ContentTypeOption = {
  label: string
  /** `undefined` for a catch-all row such as advertiser-app's "All sources". */
  value?: string
  contentTypes: ListItems
  narrowable?: boolean
}
